import { render, staticRenderFns } from "./actMaleRules.vue?vue&type=template&id=5a38b36d&scoped=true"
import script from "./actMaleRules.vue?vue&type=script&lang=js"
export * from "./actMaleRules.vue?vue&type=script&lang=js"
import style0 from "./actMaleRules.vue?vue&type=style&index=0&id=5a38b36d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a38b36d",
  null
  
)

export default component.exports